module.exports = __webpack_public_path__ + "img/logo.786b7e54.png";